export const NAME = 'appointmentFiles';